import {Formik} from 'formik';
import {Alert, AlertTitle, Box, Button, Container, TextField, Typography} from '@mui/material';
import React, {useState} from 'react';
import {Helmet} from 'react-helmet';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as Yup from 'yup';
import IyoAuth from '../../../auth/Auth';
import {setAttemptedLogin} from '../../../userContextSlice';

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState(null);

  const handleLoginSubmit = (values, actions) => {
    const payload = {
      attemptedLoginUser: values.username,
      attemptedLoginPass: values.password
    };
    dispatch(setAttemptedLogin(payload));

    IyoAuth.login(values.username, values.password)
      .then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          history.push('/changepassword');
        }
        else {
          history.push('/');
        }
      })
      .catch((error) => {
        console.log(error);
        setError(error);
        actions.setSubmitting(false);
      });
  };

  return (
    <Box>
      <Helmet>
        <title>Login | nGEST</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth='sm'>
          {error?.message ? (
            <Alert severity='error' sx={{my: 2}}>
              <AlertTitle>Login Failed</AlertTitle>
              Invalid user/credentials
            </Alert>
          ) : (<></>)}
          <Formik
            initialValues={{
              username: '',
              password: '',
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string().max(255).required('Username is required'),
              password: Yup.string().max(255).required('Password is required'),
            })}
            onSubmit={(values, actions) => handleLoginSubmit(values, actions)}
          >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    color='textPrimary'
                    variant='h2'
                  >
                    Sign in
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.username && errors.username)}
                  fullWidth
                  helperText={touched.username && errors.username}
                  label='Username'
                  margin='normal'
                  name='username'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type='username'
                  value={values.username}
                  variant='outlined'
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label='Password'
                  margin='normal'
                  name='password'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type='password'
                  value={values.password}
                  variant='outlined'
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color='primary'
                    disabled={isSubmitting}
                    fullWidth
                    size='large'
                    type='submit'
                    variant='contained'
                  >
                    Sign in now
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Box>
  );
};

export default Login;
